






































































































































import ServiceAppointComponent from "@c/Home/Services/ServiceAppoint/ServiceAppointComponent";
export default ServiceAppointComponent;
